module.exports = __webpack_public_path__ + "static/Akili Interactive Labs-5799d4d930e103995caa3a9411511d1e.jpg";